import React from 'react'
import Layout from './Layout'
import NavigationNew from '../Navigation/Navigation-New'
import { ART_ICONS } from './art-icons'
import BreadCum from './bread-cum'
import { useTranslation } from 'react-i18next'

export default function LayoutWithOutAccountCard({
  children,
  showEmptySpace = false,
  keyPath = '',
  breadCumKey = '',
}) {
  const iconDetails = ART_ICONS.filter((ele) => ele.key === keyPath)[0]
  const {t}=useTranslation()
  return (
    <Layout>
      <div className='d-flex'>
        <NavigationNew />
        <div style={{ width: '100%' }}>
          <BreadCum breadCumKey={breadCumKey} />
          <div className='d-flex'>
            {showEmptySpace && (
              <div className='desc-section' style={{ width: 450 }}>
                <img width={230} height={140} src={iconDetails?.descIcon} />
                <p className='text-center'>{t(iconDetails?.desc)}</p>
              </div>
            )}
            <div style={{ width: '100%', paddingLeft: 20 }}>{children}</div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
